import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/SlideShowReports/Get`, payload),
    Chart: (payload) => Repository.post(`/api/SlideShowReports/Chart`, payload),
    Report: (payload) => Repository.post(`/api/SlideShowReports/Report`, payload),
}
